import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WalletsPage.KycPage.wizard.PersonsDetailsStep.VerificationTable', {
    name: 'Name',
    role: 'Role',
    status: 'Status',
    verification: 'Verification',
    InvitationSent: 'Invitation sent',
    NotReady: 'Not ready',
    Ready: 'Ready',
    fillForm: 'Fill form',
    edit: 'Edit',
});
